function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref4bb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref4bb"] = parcelRequire;
}
parcelRequire.register("1xelg", function(module, exports) {

$parcel$export(module.exports, "default", () => $11e3ff8dc91f8d4a$export$2e2bcd8739ae039);

var $h3sYy = parcelRequire("h3sYy");
// the global Kabelwerk object
const $11e3ff8dc91f8d4a$var$Kabelwerk = (0, $h3sYy.initKabelwerk)();
var $11e3ff8dc91f8d4a$export$2e2bcd8739ae039 = $11e3ff8dc91f8d4a$var$Kabelwerk;

});
parcelRequire.register("h3sYy", function(module, exports) {

$parcel$export(module.exports, "initKabelwerk", () => $c6a93172efa9b2d4$export$885541371efc50d2);

var $73WGD = parcelRequire("73WGD");

var $geSD5 = parcelRequire("geSD5");

var $dabqq = parcelRequire("dabqq");

var $laGHD = parcelRequire("laGHD");

var $fJVWF = parcelRequire("fJVWF");

var $aM4q9 = parcelRequire("aM4q9");

var $czhuu = parcelRequire("czhuu");

var $7Bf0F = parcelRequire("7Bf0F");

var $c7j6M = parcelRequire("c7j6M");

var $leTO7 = parcelRequire("leTO7");
// Init a Kabelwerk object.
//
// In production there should be only one Kabelwerk object; however, testing is
// easier when we have a constructor function.
//
const $c6a93172efa9b2d4$export$885541371efc50d2 = function() {
    const config = {
        url: "wss://hub.kabelwerk.io/socket/user",
        token: "",
        refreshToken: null,
        logging: "silent"
    };
    const dispatcher = (0, $geSD5.initDispatcher)([
        "error",
        "ready",
        "connected",
        "disconnected",
        "user_updated"
    ]);
    let connector = null;
    let user = null;
    let ready = false;
    // the user's private channel
    let privateChannel = null;
    let privateChannelJoinRes = {};
    const setupPrivateChannel = function() {
        privateChannel = connector.getSocket().channel("private", function() {
            const params = {};
            if (config.ensureRooms) params.ensure_rooms = config.ensureRooms;
            return params;
        });
        privateChannel.on("user_updated", function(payload) {
            user = (0, $czhuu.parseOwnUser)(payload);
            dispatcher.send("user_updated", user);
        });
        privateChannel.join().receive("ok", function(payload) {
            (0, $fJVWF.default).info("Joined the user's private channel.");
            privateChannelJoinRes = (0, $czhuu.parsePrivateJoin)(payload);
            if (user) user = privateChannelJoinRes.user;
            else {
                user = privateChannelJoinRes.user;
                dispatcher.send("user_updated", user);
            }
            if (!ready) {
                ready = true;
                dispatcher.send("ready", {
                    user: user
                });
            }
        }).receive("error", function(error) {
            (0, $fJVWF.default).error("Failed to join the user's private channel.", error);
            dispatcher.send("error", (0, $dabqq.PushRejected)());
            // if we cannot (re-)join the private channel, then terminate
            // the connection
            disconnect();
        }).receive("timeout", function() {
            dispatcher.send("error", (0, $dabqq.Timeout)());
        });
    };
    const ensureReady = function() {
        if (!connector || !ready) throw (0, $dabqq.UsageError)("The Kabelwerk object is not ready yet.");
    };
    const callApi = function(method, path, data) {
        ensureReady();
        return connector.callApi(method, path, data);
    };
    const disconnect = function() {
        if (privateChannel) privateChannel.leave();
        privateChannel = null;
        if (connector) connector.disconnect();
        connector = null;
        dispatcher.off();
        user = null;
        ready = false;
    };
    return {
        config: function(params) {
            params = (0, $c7j6M.validateParams)(params, {
                url: {
                    type: "string",
                    optional: true
                },
                token: {
                    type: "string",
                    optional: true
                },
                refreshToken: {
                    type: "function",
                    optional: true
                },
                ensureRooms: {
                    type: "iterable",
                    optional: true,
                    each: function(hubSlug) {
                        return (0, $c7j6M.validate)(hubSlug, {
                            type: "string"
                        });
                    }
                },
                logging: {
                    type: "string",
                    optional: true
                },
                _agent: {
                    type: "string",
                    optional: true
                }
            });
            for (let [key, value] of params.entries())config[key] = value;
            (0, $fJVWF.default).setLevel(config.logging);
        },
        // Open a websocket connection to the Kabelwerk backend.
        //
        connect: function() {
            if (connector) {
                const word = connector.getState() == (0, $73WGD.ONLINE) ? "online" : "connecting";
                throw (0, $dabqq.UsageError)(`Kabewerk is already ${word}.`);
            }
            connector = (0, $73WGD.initConnector)(config, dispatcher);
            dispatcher.once("connected", setupPrivateChannel);
            connector.connect();
        },
        // Create a room for the connected user. Return a promise resolving
        // into an object with the newly created room's ID.
        //
        createRoom: function(hubIdOrSlug) {
            ensureReady();
            try {
                (0, $c7j6M.validateOneOf)(hubIdOrSlug, [
                    {
                        type: "integer"
                    },
                    {
                        type: "string"
                    }
                ]);
            } catch (error) {
                throw (0, $dabqq.UsageError)("The hub ID must be an integer or a string.");
            }
            return new Promise(function(resolve, reject) {
                privateChannel.push("create_room", {
                    hub: hubIdOrSlug
                }).receive("ok", function(payload) {
                    resolve({
                        id: payload.id
                    });
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to create a new room.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Close the currently active websocket connection to the backend and
        // reset the internal state.
        //
        disconnect: disconnect,
        // Return the current connection state.
        //
        getState: function() {
            if (connector) return connector.getState();
            else return 0, $73WGD.INACTIVE;
        },
        // Return the connected user's info.
        //
        getUser: function() {
            ensureReady();
            return user;
        },
        // Retrieve info about the user's hub (name, list of fellow hub users).
        // Return a promise resolving into that info.
        //
        // This method only works for hub users.
        //
        loadHubInfo: function() {
            ensureReady();
            return new Promise(function(resolve, reject) {
                let push = privateChannel.push("get_hub", {});
                push.receive("ok", function(payload) {
                    resolve((0, $czhuu.parseOwnHub)(payload));
                });
                push.receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to load the user hub's info.", error);
                    reject((0, $dabqq.PushRejected)());
                });
                push.receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        off: dispatcher.off,
        on: dispatcher.on,
        once: dispatcher.once,
        // Init and return an inbox object.
        //
        // The params are validated by the inbox object.
        //
        openInbox: function(params) {
            ensureReady();
            return (0, $laGHD.initInbox)(connector.getSocket(), user, params);
        },
        // Init and return a notifier object.
        //
        openNotifier: function() {
            ensureReady();
            return (0, $aM4q9.initNotifier)(connector.getSocket(), user);
        },
        // Init and return a room object.
        //
        openRoom: function(roomId = 0) {
            ensureReady();
            try {
                (0, $c7j6M.validate)(roomId, {
                    type: "integer"
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The room ID must be an integer.");
            }
            if (roomId == 0) {
                if (privateChannelJoinRes.roomIds.length) roomId = privateChannelJoinRes.roomIds[0];
                else throw (0, $dabqq.UsageError)("The user does not have any rooms.");
            }
            return (0, $7Bf0F.initRoom)(connector.getSocket(), user, roomId, callApi);
        },
        // Ping the Kabelwerk server and invoke the given callback with the
        // round-trip time in milliseconds when the response is received.
        //
        // Return a boolean indicating whether the ping has been sent.
        //
        ping: function(callback) {
            try {
                (0, $c7j6M.validate)(callback, {
                    type: "function"
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The callback must be a function.");
            }
            if (!connector) return false;
            return connector.getSocket().ping(callback);
        },
        // Update the push notifications settings for the currently connected
        // device. Return a promise resolving into the updated device info.
        //
        updateDevice: function(params) {
            ensureReady();
            params = (0, $c7j6M.validateParams)(params, {
                pushNotificationsToken: {
                    type: "string"
                },
                pushNotificationsEnabled: {
                    type: "boolean"
                }
            });
            const pushParams = {
                push_notifications_token: params.get("pushNotificationsToken"),
                push_notifications_enabled: params.get("pushNotificationsEnabled")
            };
            return new Promise(function(resolve, reject) {
                privateChannel.push("update_device", pushParams).receive("ok", function(payload) {
                    const device = (0, $czhuu.parseDevice)(payload);
                    resolve(device);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to update the device's push notifications settings.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Update the connected user's info. Return a promise resolving into
        // the (updated) user info.
        //
        updateUser: function(params) {
            ensureReady();
            params = (0, $c7j6M.validateParams)(params, {
                name: {
                    type: "string",
                    optional: true
                }
            });
            return new Promise(function(resolve, reject) {
                privateChannel.push("update_user", Object.fromEntries(params)).receive("ok", function(payload) {
                    user = (0, $czhuu.parseOwnUser)(payload);
                    resolve(user);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to update the user's info.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        INACTIVE: // connection states
        $73WGD.INACTIVE,
        CONNECTING: $73WGD.CONNECTING,
        ONLINE: $73WGD.ONLINE,
        VERSION: // SDK version
        $leTO7.VERSION
    };
};

});
parcelRequire.register("73WGD", function(module, exports) {

$parcel$export(module.exports, "INACTIVE", () => $5246562c626ae381$export$1635bbf8efc1cbc4);
$parcel$export(module.exports, "CONNECTING", () => $5246562c626ae381$export$93594b43c988aea3);
$parcel$export(module.exports, "ONLINE", () => $5246562c626ae381$export$753f024675a52aa3);
$parcel$export(module.exports, "initConnector", () => $5246562c626ae381$export$688bfd67795cdf25);

var $9qlM0 = parcelRequire("9qlM0");

var $dabqq = parcelRequire("dabqq");

var $fJVWF = parcelRequire("fJVWF");

var $leTO7 = parcelRequire("leTO7");
const $5246562c626ae381$export$1635bbf8efc1cbc4 = 0;
const $5246562c626ae381$export$93594b43c988aea3 = 1;
const $5246562c626ae381$export$753f024675a52aa3 = 2;
// Return the websocket and API URLs from the URL provided in the config.
//
// We cannot parse and normalise the input by using a URL object as it is not
// supported by React Native.
//
const $5246562c626ae381$export$b81226f9545ba1ff = function(configUrl) {
    const regex = /^(wss?:\/\/)?([0-9a-z.:-]+)\/?([a-z\/]+)?$/i;
    const match = configUrl.match(regex);
    if (!match) throw (0, $dabqq.UsageError)(`${configUrl} is not a valid Kabelwerk URL.`);
    const scheme = match[1] ? match[1] : "wss://";
    const host = match[2];
    const path = match[3] ? "/" + match[3] : "/socket/user";
    const apiScheme = scheme == "wss://" ? "https://" : "http://";
    return [
        scheme + host + path,
        apiScheme + host + "/socket-api"
    ];
};
// Init a connector.
//
// A connector is a wrapper around a Phoenix socket, which maintains the
// Kabelwerk state (see the constants above), and handles auth token obtaining
// (before the first connect) and refreshing (after an unexpected disconnect).
// It also makes easier testing and reseting of Kabelwerk objects.
//
// In addition, the connector object also handles the API requests.
//
const $5246562c626ae381$export$688bfd67795cdf25 = function(config, dispatcher) {
    let state = $5246562c626ae381$export$1635bbf8efc1cbc4;
    let token = config.token;
    let tokenIsRefreshing = false;
    // enable the Kabelwerk SDK for React Native (and potentially others) to
    // overwrite the default agent via the undocumented _agent config
    const agent = config._agent ? config._agent : `sdk-js/${0, $leTO7.VERSION}`;
    // infer the websocket and API URLs — or raise an error if the config URL
    // is invalid
    const [url, apiUrl] = $5246562c626ae381$export$b81226f9545ba1ff(config.url);
    // the phoenix socket
    const socket = new (0, $9qlM0.Socket)(url, {
        params: function() {
            return {
                token: token,
                agent: agent
            };
        },
        logger: function(kind, msg, data) {
            (0, $fJVWF.default).debug(`${kind}: ${msg}`, data);
        }
    });
    // fired when the websocket connection is opened
    socket.onOpen(function() {
        (0, $fJVWF.default).info("Websocket connection opened.");
        state = $5246562c626ae381$export$753f024675a52aa3;
        dispatcher.send("connected", {
            state: state
        });
    });
    // fired when the websocket connection is closed
    socket.onClose(function(event) {
        (0, $fJVWF.default).info("Websocket connection closed.", event);
        // the same condition as the one used by Phoenix
        if (!event.wasClean && event.code != 1000) state = $5246562c626ae381$export$93594b43c988aea3;
        else state = $5246562c626ae381$export$1635bbf8efc1cbc4;
        dispatcher.send("disconnected", {
            state: state
        });
        if (state == $5246562c626ae381$export$93594b43c988aea3 && config.refreshToken && !tokenIsRefreshing) {
            tokenIsRefreshing = true;
            config.refreshToken(token).then(function(newToken) {
                (0, $fJVWF.default).info("Auth token refreshed.");
                token = newToken;
                tokenIsRefreshing = false;
            }).catch(function(error) {
                (0, $fJVWF.default).error("Failed to refresh the auth token.", error);
                tokenIsRefreshing = false;
            });
        }
    });
    // fired when the websocket connection is closed because of an error
    // the onClose handler takes care of updating the state
    socket.onError(function(event) {
        (0, $fJVWF.default).error("Websocket connection error.", event);
        dispatcher.send("error", (0, $dabqq.ConnectionError)("Closed the websocket connection due to an error.", event));
    });
    // set the token and call socket.connect()
    const connect = function() {
        // if the connector is configured with a token — use it, regardless of
        // whether it is also configured with a refreshToken function
        if (token) {
            state = $5246562c626ae381$export$93594b43c988aea3;
            return socket.connect();
        }
        // if the connector is not configured with a token — call refreshToken
        // to obtain the initial token
        if (config.refreshToken) {
            state = $5246562c626ae381$export$93594b43c988aea3;
            return config.refreshToken(token).then(function(newToken) {
                (0, $fJVWF.default).info("Auth token obtained.");
                token = newToken;
                socket.connect();
            }).catch(function(error) {
                (0, $fJVWF.default).error("Failed to obtain an auth token.", error);
                state = $5246562c626ae381$export$1635bbf8efc1cbc4;
                dispatcher.send("error", (0, $dabqq.ConnectionError)("Failed to obtain an auth token.", error));
            });
        }
        throw (0, $dabqq.UsageError)("Kabelwerk must be configured with either a token or a refreshToken function in order to connect to the server.");
    };
    // helper for the function below
    const sendApiRequest = function(method, path, data, token) {
        return fetch(apiUrl + path, {
            method: method,
            headers: {
                "Kabelwerk-Token": token,
                "User-Agent": agent
            },
            body: data
        });
    };
    // make an API call
    const callApi = function(method, path, data) {
        return sendApiRequest(method, path, data, token).then(function(response) {
            // if the request got rejected with 401, refresh the token and
            // try again
            if (response.status == 401 && config.refreshToken && !tokenIsRefreshing) return config.refreshToken(token).then(function(newToken) {
                if (!tokenIsRefreshing) {
                    (0, $fJVWF.default).info("Auth token refreshed.");
                    token = newToken;
                }
                return sendApiRequest(method, path, data, newToken);
            });
            return response;
        }).then(function(response) {
            if (response.ok) return response.json();
            else throw (0, $dabqq.RequestRejected)("The server rejected the request with the following error: " + `${response.status} — ${response.statusText}`, response);
        }).catch(function(error) {
            if (error.name == (0, $dabqq.REQUEST_REJECTED)) throw error;
            else throw (0, $dabqq.ConnectionError)("The request failed to reach the server.", error);
        });
    };
    return {
        callApi: callApi,
        connect: connect,
        disconnect: function() {
            socket.disconnect();
        },
        getSocket: function() {
            return socket;
        },
        getState: function() {
            return state;
        }
    };
};

});
parcelRequire.register("9qlM0", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $2eec714441ac83b3$export$4798917dbf149b79);
// js/phoenix/utils.js
var $2eec714441ac83b3$var$closure = (value)=>{
    if (typeof value === "function") return value;
    else {
        let closure2 = function() {
            return value;
        };
        return closure2;
    }
};
// js/phoenix/constants.js
var $2eec714441ac83b3$var$globalSelf = typeof self !== "undefined" ? self : null;
var $2eec714441ac83b3$var$phxWindow = typeof window !== "undefined" ? window : null;
var $2eec714441ac83b3$var$global = $2eec714441ac83b3$var$globalSelf || $2eec714441ac83b3$var$phxWindow || $2eec714441ac83b3$var$global;
var $2eec714441ac83b3$var$DEFAULT_VSN = "2.0.0";
var $2eec714441ac83b3$var$SOCKET_STATES = {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $2eec714441ac83b3$var$DEFAULT_TIMEOUT = 1e4;
var $2eec714441ac83b3$var$WS_CLOSE_NORMAL = 1e3;
var $2eec714441ac83b3$var$CHANNEL_STATES = {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $2eec714441ac83b3$var$CHANNEL_EVENTS = {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $2eec714441ac83b3$var$TRANSPORTS = {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $2eec714441ac83b3$var$XHR_STATES = {
    complete: 4
};
// js/phoenix/push.js
var $2eec714441ac83b3$var$Push = class {
    constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {*} status
   * @param {*} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    /**
   * @private
   */ reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    /**
   * @private
   */ cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    /**
   * @private
   */ startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    /**
   * @private
   */ trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
// js/phoenix/timer.js
var $2eec714441ac83b3$var$Timer = class {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = null;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
// js/phoenix/channel.js
var $2eec714441ac83b3$export$cfdacaa37f9b4dd7 = class {
    constructor(topic, params, socket){
        this.state = $2eec714441ac83b3$var$CHANNEL_STATES.closed;
        this.topic = topic;
        this.params = $2eec714441ac83b3$var$closure(params || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $2eec714441ac83b3$var$Push(this, $2eec714441ac83b3$var$CHANNEL_EVENTS.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $2eec714441ac83b3$var$Timer(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $2eec714441ac83b3$var$CHANNEL_STATES.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", ()=>{
            this.state = $2eec714441ac83b3$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic} ${this.joinRef()}`);
            this.state = $2eec714441ac83b3$var$CHANNEL_STATES.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $2eec714441ac83b3$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic} (${this.joinRef()})`, this.joinPush.timeout);
            let leavePush = new $2eec714441ac83b3$var$Push(this, $2eec714441ac83b3$var$CHANNEL_EVENTS.leave, $2eec714441ac83b3$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $2eec714441ac83b3$var$CHANNEL_STATES.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($2eec714441ac83b3$var$CHANNEL_EVENTS.reply, (payload, ref)=>{
            this.trigger(this.replyEventName(ref), payload);
        });
    }
    /**
   * Join the channel
   * @param {integer} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Hook into channel close
   * @param {Function} callback
   */ onClose(callback) {
        this.on($2eec714441ac83b3$var$CHANNEL_EVENTS.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {Function} callback
   */ onError(callback) {
        return this.on($2eec714441ac83b3$var$CHANNEL_EVENTS.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {Function} callback
   * @returns {integer} ref
   */ on(event, callback) {
        let ref = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref,
            callback: callback
        });
        return ref;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {integer} ref
   */ off(event, ref) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref === "undefined" || ref === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $2eec714441ac83b3$var$Push(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {integer} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $2eec714441ac83b3$var$CHANNEL_STATES.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($2eec714441ac83b3$var$CHANNEL_EVENTS.close, "leave");
        };
        let leavePush = new $2eec714441ac83b3$var$Push(this, $2eec714441ac83b3$var$CHANNEL_EVENTS.leave, $2eec714441ac83b3$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @param {string} event
   * @param {Object} payload
   * @param {integer} ref
   * @returns {Object}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * @private
   */ isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    /**
   * @private
   */ joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $2eec714441ac83b3$var$CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @private
   */ trigger(event, payload, ref, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event);
        for(let i = 0; i < eventBindings.length; i++){
            let bind = eventBindings[i];
            bind.callback(handledPayload, ref, joinRef || this.joinRef());
        }
    }
    /**
   * @private
   */ replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /**
   * @private
   */ isClosed() {
        return this.state === $2eec714441ac83b3$var$CHANNEL_STATES.closed;
    }
    /**
   * @private
   */ isErrored() {
        return this.state === $2eec714441ac83b3$var$CHANNEL_STATES.errored;
    }
    /**
   * @private
   */ isJoined() {
        return this.state === $2eec714441ac83b3$var$CHANNEL_STATES.joined;
    }
    /**
   * @private
   */ isJoining() {
        return this.state === $2eec714441ac83b3$var$CHANNEL_STATES.joining;
    }
    /**
   * @private
   */ isLeaving() {
        return this.state === $2eec714441ac83b3$var$CHANNEL_STATES.leaving;
    }
};
// js/phoenix/ajax.js
var $2eec714441ac83b3$var$Ajax = class {
    static request(method, endPoint, accept, body, timeout, ontimeout, callback) {
        if ($2eec714441ac83b3$var$global.XDomainRequest) {
            let req = new $2eec714441ac83b3$var$global.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else {
            let req = new $2eec714441ac83b3$var$global.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, accept, body, timeout, ontimeout, callback);
        }
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, accept, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        req.setRequestHeader("Content-Type", accept);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $2eec714441ac83b3$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch (e) {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        let prefix = url.match(/\?/) ? "&" : "?";
        return `${url}${prefix}${this.serialize(params)}`;
    }
};
// js/phoenix/longpoll.js
var $2eec714441ac83b3$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
var $2eec714441ac83b3$export$57a2cdf8ead4f893 = class {
    constructor(endPoint){
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $2eec714441ac83b3$var$SOCKET_STATES.connecting;
        this.poll();
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $2eec714441ac83b3$var$TRANSPORTS.websocket), "$1/" + $2eec714441ac83b3$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $2eec714441ac83b3$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $2eec714441ac83b3$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $2eec714441ac83b3$var$SOCKET_STATES.open || this.readyState === $2eec714441ac83b3$var$SOCKET_STATES.connecting;
    }
    poll() {
        this.ajax("GET", "application/json", null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $2eec714441ac83b3$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $2eec714441ac83b3$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages) {
        this.awaitingBatchAck = true;
        this.ajax("POST", "application/x-ndjson", messages.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            this.awaitingBatchAck = false;
            if (!resp || resp.status !== 200) {
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            }
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $2eec714441ac83b3$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, contentType, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $2eec714441ac83b3$var$Ajax.request(method, this.endpointURL(), contentType, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
// js/phoenix/presence.js
var $2eec714441ac83b3$export$99c2b779aa4e8b8b = class {
    constructor(channel, opts = {}){
        let events = opts.events || {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = {};
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = $2eec714441ac83b3$export$99c2b779aa4e8b8b.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $2eec714441ac83b3$export$99c2b779aa4e8b8b.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $2eec714441ac83b3$export$99c2b779aa4e8b8b.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    onJoin(callback) {
        this.caller.onJoin = callback;
    }
    onLeave(callback) {
        this.caller.onLeave = callback;
    }
    onSync(callback) {
        this.caller.onSync = callback;
    }
    list(by) {
        return $2eec714441ac83b3$export$99c2b779aa4e8b8b.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @returns {Presence}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.clone(currentState);
        let joins = {};
        let leaves = {};
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m)=>m.phx_ref);
                let curRefs = currentPresence.metas.map((m)=>m.phx_ref);
                let joinedMetas = newPresence.metas.filter((m)=>curRefs.indexOf(m.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m)=>newRefs.indexOf(m.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @returns {Presence}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m)=>m.phx_ref);
                let curMetas = currentPresence.metas.filter((m)=>joinedRefs.indexOf(m.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m)=>m.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p)=>{
                return refsToRemove.indexOf(p.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @param {Object} presences
   * @param {Function} chooser
   *
   * @returns {Presence}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
// js/phoenix/serializer.js
var $2eec714441ac83b3$export$ef852775387a0be7 = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    // private
    binaryEncode (message) {
        let { join_ref: join_ref, ref: ref, event: event, topic: topic, payload: payload } = message;
        let metaLength = this.META_LENGTH + join_ref.length + ref.length + topic.length + event.length;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.push);
        view.setUint8(offset++, join_ref.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, event.length);
        Array.from(join_ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(ref, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(topic, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        Array.from(event, (char)=>view.setUint8(offset++, char.charCodeAt(0)));
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    },
    decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let ref = decoder.decode(buffer.slice(offset, offset + refSize));
        offset = offset + refSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        let payload = {
            status: event,
            response: data
        };
        return {
            join_ref: joinRef,
            ref: ref,
            topic: topic,
            event: $2eec714441ac83b3$var$CHANNEL_EVENTS.reply,
            payload: payload
        };
    },
    decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
};
// js/phoenix/socket.js
var $2eec714441ac83b3$export$4798917dbf149b79 = class {
    constructor(endPoint, opts = {}){
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.timeout = opts.timeout || $2eec714441ac83b3$var$DEFAULT_TIMEOUT;
        this.transport = opts.transport || $2eec714441ac83b3$var$global.WebSocket || $2eec714441ac83b3$export$57a2cdf8ead4f893;
        this.establishedConnections = 0;
        this.defaultEncoder = $2eec714441ac83b3$export$ef852775387a0be7.encode.bind($2eec714441ac83b3$export$ef852775387a0be7);
        this.defaultDecoder = $2eec714441ac83b3$export$ef852775387a0be7.decode.bind($2eec714441ac83b3$export$ef852775387a0be7);
        this.closeWasClean = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        if (this.transport !== $2eec714441ac83b3$export$57a2cdf8ead4f893) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($2eec714441ac83b3$var$phxWindow && $2eec714441ac83b3$var$phxWindow.addEventListener) {
            $2eec714441ac83b3$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $2eec714441ac83b3$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $2eec714441ac83b3$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$2eec714441ac83b3$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $2eec714441ac83b3$var$DEFAULT_VSN;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $2eec714441ac83b3$var$Timer(()=>{
            this.teardown(()=>this.connect());
        }, this.reconnectAfterMs);
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $2eec714441ac83b3$export$57a2cdf8ead4f893;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {Function} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        this.reconnectTimer.reset();
        this.sendBuffer = [];
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {string}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $2eec714441ac83b3$var$Ajax.appendParams($2eec714441ac83b3$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {Function} callback - Optional callback which is called after socket is disconnected.
   * @param {integer} code - A status code for disconnection (Optional).
   * @param {string} reason - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.closeWasClean = true;
        this.reconnectTimer.reset();
        this.teardown(callback, code, reason);
    }
    /**
   *
   * @param {Object} params - The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params) {
        if (params) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $2eec714441ac83b3$var$closure(params);
        }
        if (this.conn) return;
        this.connectClock++;
        this.closeWasClean = false;
        this.conn = new this.transport(this.endPointURL());
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {Function} callback
   */ onOpen(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection close events
   * @param {Function} callback
   */ onClose(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {Function} callback
   */ onError(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection message events
   * @param {Function} callback
   */ onMessage(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {Function} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   */ clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        this.resetHeartbeat();
        this.stateChangeCallbacks.open.forEach(([, callback])=>callback());
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            this.triggerChanError();
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $2eec714441ac83b3$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        this.waitForBufferDone(()=>{
            if (this.conn) {
                if (code) this.conn.close(code, reason || "");
                else this.conn.close();
            }
            this.waitForSocketClosed(()=>{
                if (this.conn) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(callback, tries = 1) {
        if (tries === 5 || !this.conn || !this.conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(callback, tries = 1) {
        if (tries === 5 || !this.conn || this.conn.readyState === $2eec714441ac83b3$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(callback, tries + 1);
        }, 150 * tries);
    }
    onConnClose(event) {
        let closeCode = event && event.code;
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError();
        this.clearHeartbeats();
        if (!this.closeWasClean && closeCode !== 1e3) this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach(([, callback])=>callback(event));
    }
    /**
   * @private
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.stateChangeCallbacks.error.forEach(([, callback])=>{
            callback(error, transportBefore, establishedBefore);
        });
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError();
    }
    /**
   * @private
   */ triggerChanError() {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($2eec714441ac83b3$var$CHANNEL_EVENTS.error);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $2eec714441ac83b3$var$SOCKET_STATES.connecting:
                return "connecting";
            case $2eec714441ac83b3$var$SOCKET_STATES.open:
                return "open";
            case $2eec714441ac83b3$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   * @private
   *
   * @param {Channel}
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c)=>c.joinRef() !== channel.joinRef());
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {refs} - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref])=>{
            return refs.indexOf(ref) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Object} chanParams - Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $2eec714441ac83b3$export$cfdacaa37f9b4dd7(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Object} data
   */ push(data) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = data;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref})`, payload);
        }
        if (this.isConnected()) this.encode(data, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (this.pendingHeartbeatRef && !this.isConnected()) return;
        this.pendingHeartbeatRef = this.makeRef();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) {
                this.clearHeartbeats();
                this.pendingHeartbeatRef = null;
                this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`, payload);
            for(let i = 0; i < this.channels.length; i++){
                const channel = this.channels[i];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref, join_ref);
            }
            for(let i = 0; i < this.stateChangeCallbacks.message.length; i++){
                let [, callback] = this.stateChangeCallbacks.message[i];
                callback(msg);
            }
        });
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c.isJoined() || c.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};

});

parcelRequire.register("dabqq", function(module, exports) {

$parcel$export(module.exports, "REQUEST_REJECTED", () => $99551251acfc1eff$export$1e03a19f8b6233a0);
$parcel$export(module.exports, "UsageError", () => $99551251acfc1eff$export$73b43d6324d1c408);
$parcel$export(module.exports, "ConnectionError", () => $99551251acfc1eff$export$a3747c6e46c7a8eb);
$parcel$export(module.exports, "PushRejected", () => $99551251acfc1eff$export$6680330c13a7eeec);
$parcel$export(module.exports, "RequestRejected", () => $99551251acfc1eff$export$9bb884c68535da2c);
$parcel$export(module.exports, "Timeout", () => $99551251acfc1eff$export$786b4da70f00938b);
// This module contains the errors which are raised or returned by the SDK.
//
// The errors are standard Error instances with the name attribute set to a
// string specifying the error type. This is because extending the built-in
// Error class is not well supported in JavaScript.
//
// Example usage:
//
//  throw UsageError('This is how you raise an error!');
//  throw Timeout();
//
//
// the error names (types)
//
const $99551251acfc1eff$export$c936f9b09d6db558 = "UsageError";
const $99551251acfc1eff$export$55dd770698760681 = "ConnectionError";
const $99551251acfc1eff$export$b06e6b43167cdcd2 = "PushRejected";
const $99551251acfc1eff$export$1e03a19f8b6233a0 = "RequestRejected";
const $99551251acfc1eff$export$3cf918ebc7e29d7a = "Timeout";
const $99551251acfc1eff$export$73b43d6324d1c408 = function(message) {
    if (!message) message = "Unexpected usage.";
    const error = new Error(message);
    error.name = $99551251acfc1eff$export$c936f9b09d6db558;
    return error;
};
const $99551251acfc1eff$export$a3747c6e46c7a8eb = function(message, cause) {
    if (!message) message = "Failed to connect to the server.";
    const error = new Error(message);
    error.name = $99551251acfc1eff$export$55dd770698760681;
    error.cause = cause;
    return error;
};
const $99551251acfc1eff$export$6680330c13a7eeec = function(message) {
    if (!message) message = "The server rejected the request.";
    const error = new Error(message);
    error.name = $99551251acfc1eff$export$b06e6b43167cdcd2;
    return error;
};
const $99551251acfc1eff$export$9bb884c68535da2c = function(message, response) {
    if (!message) message = "The server rejected the request.";
    const error = new Error(message);
    error.name = $99551251acfc1eff$export$1e03a19f8b6233a0;
    error.cause = response;
    return error;
};
const $99551251acfc1eff$export$786b4da70f00938b = function(message) {
    if (!message) message = "The server timed out.";
    const error = new Error(message);
    error.name = $99551251acfc1eff$export$3cf918ebc7e29d7a;
    return error;
};

});

parcelRequire.register("fJVWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b75801b13e088df2$export$2e2bcd8739ae039);

var $dabqq = parcelRequire("dabqq");
// logging levels
const $b75801b13e088df2$var$LEVELS = {
    SILENT: 60,
    ERROR: 40,
    INFO: 20,
    DEBUG: 10
};
// Init the logger singleton obejct.
//
const $b75801b13e088df2$var$logger = function() {
    let level = 60; // silent by default
    const debug = function(message, obj = " ") {
        if ($b75801b13e088df2$var$LEVELS.DEBUG >= level) console && console.debug("[Kabelwerk]", message, obj);
    };
    const info = function(message, obj = " ") {
        if ($b75801b13e088df2$var$LEVELS.INFO >= level) console && console.info("[Kabelwerk]", message, obj);
    };
    const error = function(message, obj = " ") {
        if ($b75801b13e088df2$var$LEVELS.ERROR >= level) console && console.error("[Kabelwerk]", message, obj);
    };
    const setLevel = function(levelName) {
        levelName = levelName.toUpperCase();
        if (!$b75801b13e088df2$var$LEVELS.hasOwnProperty(levelName)) throw (0, $dabqq.UsageError)("The logging level has to be one of the following strings (case-insensitive): DEBUG, INFO, ERROR, SILENT.");
        level = $b75801b13e088df2$var$LEVELS[levelName];
    };
    return {
        debug: debug,
        info: info,
        error: error,
        setLevel: setLevel
    };
}();
var $b75801b13e088df2$export$2e2bcd8739ae039 = $b75801b13e088df2$var$logger;

});

parcelRequire.register("leTO7", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $f76631fb3f79da2e$export$a4ad2735b021c132);
const $f76631fb3f79da2e$export$a4ad2735b021c132 = "0.3.6";

});


parcelRequire.register("geSD5", function(module, exports) {

$parcel$export(module.exports, "initDispatcher", () => $bd285469be3ef711$export$1a00a2d090ed164f);

var $dabqq = parcelRequire("dabqq");

var $fJVWF = parcelRequire("fJVWF");
// Init a dispatcher object.
//
const $bd285469be3ef711$export$1a00a2d090ed164f = function(eventNames) {
    let callbacks = []; // list of {ref, event, fn} objects
    const checkEventName = function(eventName) {
        if (eventNames.indexOf(eventName) == -1) throw (0, $dabqq.UsageError)(`Uknown event name: ${eventName}.`);
    };
    const refGenerator = function() {
        let i = 0;
        return {
            next: function() {
                return (++i).toString();
            }
        };
    }();
    return {
        // Emit an event: invoke the callbacks listening for the event.
        //
        send: function(event, params) {
            checkEventName(event);
            (0, $fJVWF.default).debug(event, params);
            callbacks.forEach(function(callback) {
                if (callback.event == event) callback.fn(params);
            });
        },
        // Subscribe to an event. Whenever the event is triggered, the given
        // callback will be invoked.
        //
        // Return a reference which can be used to clear the callback without
        // affecting the other callbacks attached to the event.
        //
        on: function(event, fn) {
            checkEventName(event);
            let ref = refGenerator.next();
            callbacks.push({
                ref: ref,
                event: event,
                fn: fn
            });
            return ref;
        },
        // Unsubscribe from an event.
        //
        // If no reference to a particular callback is provided, clear all
        // callbacks registered with the event.
        //
        // If no event is specified, clear all registered callbacks.
        //
        off: function(event, ref) {
            if (event) {
                checkEventName(event);
                callbacks = callbacks.filter(function(callback) {
                    if (callback.event == event) {
                        if (ref) return callback.ref !== ref;
                        else return false;
                    }
                    return true;
                });
            } else callbacks = [];
        },
        // Subscribe to an event and automatically unsubscribe from it after
        // the first time the event is triggered.
        //
        once: function(event, fn) {
            checkEventName(event);
            let self = this;
            let ref = refGenerator.next();
            callbacks.push({
                ref: ref,
                event: event,
                fn: function(params) {
                    fn(params);
                    self.off(event, ref);
                }
            });
            return ref;
        }
    };
};

});

parcelRequire.register("laGHD", function(module, exports) {

$parcel$export(module.exports, "initInbox", () => $f69ba802607b9a92$export$b08de68971541911);

var $geSD5 = parcelRequire("geSD5");

var $dabqq = parcelRequire("dabqq");

var $fJVWF = parcelRequire("fJVWF");

var $czhuu = parcelRequire("czhuu");

var $c7j6M = parcelRequire("c7j6M");
// Init an inbox object.
//
// An inbox is a certain view on the list of rooms the user has access to.
//
// For hub users, the params object can include the following keys:
//
// - limit
// - archived
// - assignedTo
// - attributes
//
// For end users, only the limit is relevant.
//
// Example usage:
//
//  let inbox = Kabelwerk.openInbox({attributes: {country: 'DE'}});
//
//  inbox.once('ready', ({ items }) => {});
//  inbox.on('updated', ({ items }) => {});
//  inbox.loadMore().then(({ items }) => {});
//
const $f69ba802607b9a92$export$b08de68971541911 = function(socket, user, params = {}) {
    params = (0, $c7j6M.validateParams)(params, {
        archived: {
            type: "boolean",
            optional: true
        },
        assignedTo: {
            type: "integer",
            nullable: true,
            optional: true
        },
        attributes: {
            type: "map",
            optional: true
        },
        limit: {
            type: "integer",
            optional: true
        }
    });
    const isHubSide = Boolean(user.hubId);
    let dispatcher = (0, $geSD5.initDispatcher)([
        "error",
        "ready",
        "updated"
    ]);
    // internal state
    let items = new Map(); // room id: inbox item
    let ready = false;
    // the base params (as a map) for the list_rooms pushes
    const loadRoomsParams = function() {
        let pushParams = new Map();
        pushParams.set("limit", params.has("limit") ? params.get("limit") : 10);
        pushParams.set("offset", 0);
        if (!isHubSide) return pushParams;
        if (params.has("archived")) pushParams.set("archived", params.get("archived"));
        if (params.has("assignedTo")) pushParams.set("hub_user", params.get("assignedTo"));
        if (params.has("attributes")) pushParams.set("attributes", Object.fromEntries(params.get("attributes")));
        return pushParams;
    }();
    // helper functions
    const parseInbox = isHubSide ? (0, $czhuu.parseHubInbox) : (0, $czhuu.parseUserInbox);
    const parseInboxItem = isHubSide ? (0, $czhuu.parseHubInboxItem) : (0, $czhuu.parseUserInboxItem);
    const matchesParams = function(item) {
        if (!isHubSide) return true;
        if (params.has("archived")) {
            if (item.room.archived !== params.get("archived")) return false;
        }
        if (params.has("assignedTo")) {
            if (item.room.assignedTo !== params.get("assignedTo")) return false;
        }
        if (params.has("attributes")) for (let [key, value] of params.get("attributes").entries()){
            if (item.room.attributes[key] !== value) return false;
        }
        return true;
    };
    const listItems = function() {
        let list = Array.from(items.values());
        list.sort(function(itemA, itemB) {
            let a = itemA.message ? itemA.message.insertedAt.getTime() : null;
            let b = itemB.message ? itemB.message.insertedAt.getTime() : null;
            return b - a;
        });
        return list;
    };
    // the phoenix channel
    let channel = null;
    const setupChannel = function() {
        const topic = isHubSide ? `hub_inbox:${user.hubId}` : `user_inbox:${user.id}`;
        channel = socket.channel(topic);
        channel.on("inbox_updated", function(payload) {
            let item = parseInboxItem(payload, user);
            if (matchesParams(item)) items.set(item.room.id, item);
            else if (items.has(item.room.id)) items.delete(item.room.id);
            else return; // no change in the items list
            dispatcher.send("updated", {
                items: listItems()
            });
        });
        channel.join().receive("ok", function() {
            (0, $fJVWF.default).info(`Joined the ${topic} channel.`);
            loadItemsOnJoin();
        }).receive("error", function(error) {
            (0, $fJVWF.default).error(`Failed to join the ${topic} channel.`, error);
            dispatcher.send("error", (0, $dabqq.PushRejected)());
        }).receive("timeout", function() {
            dispatcher.send("error", (0, $dabqq.Timeout)());
        });
    };
    const loadItemsOnJoin = function() {
        let pushParams = new Map(loadRoomsParams);
        pushParams.set("offset", 0);
        if (items.size > pushParams.get("limit")) pushParams.set("limit", items.size);
        channel.push("list_rooms", Object.fromEntries(pushParams)).receive("ok", function(payload) {
            for (let item of parseInbox(payload, user).items)items.set(item.room.id, item);
            if (!ready) {
                ready = true;
                dispatcher.send("ready", {
                    items: listItems()
                });
            } else dispatcher.send("updated", {
                items: listItems()
            });
        }).receive("error", function(error) {
            (0, $fJVWF.default).error("Failed to retrieve the inbox items.", error);
            dispatcher.send("error", (0, $dabqq.PushRejected)());
        }).receive("timeout", function() {
            dispatcher.send("error", (0, $dabqq.Timeout)());
        });
    };
    const ensureHubSide = function() {
        if (!isHubSide) throw (0, $dabqq.UsageError)("This method is only available for hub users.");
    };
    return {
        connect: function() {
            if (channel) throw (0, $dabqq.UsageError)("The connect() method was already called once.");
            setupChannel();
        },
        disconnect: function() {
            dispatcher.off();
            if (channel) channel.leave();
            channel = null;
            items = new Map();
            ready = false;
        },
        // Return the list of inbox items stored locally.
        //
        listItems: listItems,
        // Load more inbox items.
        //
        // Return a promise that either resolves into the list of inbox items
        // or rejects with an error.
        //
        loadMore: function() {
            return new Promise(function(resolve, reject) {
                let pushParams = new Map(loadRoomsParams);
                pushParams.set("offset", items.size);
                channel.push("list_rooms", Object.fromEntries(pushParams)).receive("ok", function(payload) {
                    for (let item of parseInbox(payload, user).items)items.set(item.room.id, item);
                    resolve({
                        items: listItems()
                    });
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to load more inbox items.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        on: dispatcher.on,
        off: dispatcher.off,
        once: dispatcher.once,
        // Search for inbox items by user key and/or name.
        //
        // Returns a promise that either resolves into a list of inbox items or
        // rejects with an error.
        //
        search: function(params) {
            ensureHubSide();
            params = (0, $c7j6M.validateParams)(params, {
                query: {
                    type: "string"
                },
                limit: {
                    type: "integer",
                    optional: true
                },
                offset: {
                    type: "integer",
                    optional: true
                }
            });
            let pushParams = new Map(loadRoomsParams);
            pushParams.set("search_query", params.get("query"));
            pushParams.set("limit", params.has("limit") ? params.get("limit") : 10);
            pushParams.set("offset", params.has("offset") ? params.get("offset") : 0);
            return new Promise(function(resolve, reject) {
                channel.push("list_rooms", Object.fromEntries(pushParams)).receive("ok", function(payload) {
                    resolve({
                        items: parseInbox(payload, user).items
                    });
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("The search failed.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        }
    };
};

});
parcelRequire.register("czhuu", function(module, exports) {

$parcel$export(module.exports, "parsePrivateJoin", () => $92665236b05ab7ca$export$fc00c196eb0077fe);
$parcel$export(module.exports, "parseOwnUser", () => $92665236b05ab7ca$export$59fec32f29a48331);
$parcel$export(module.exports, "parseOwnHub", () => $92665236b05ab7ca$export$e04f62a6c38c2e03);
$parcel$export(module.exports, "parseDevice", () => $92665236b05ab7ca$export$1ffd67e37223c3ea);
$parcel$export(module.exports, "parseUserInboxItem", () => $92665236b05ab7ca$export$54e25dcc64647fc8);
$parcel$export(module.exports, "parseMessage", () => $92665236b05ab7ca$export$f2f615077a189f21);
$parcel$export(module.exports, "parseUserInbox", () => $92665236b05ab7ca$export$2f0b934ecc764c66);
$parcel$export(module.exports, "parseHubInboxItem", () => $92665236b05ab7ca$export$a425ed7c68a2849d);
$parcel$export(module.exports, "parseHubInbox", () => $92665236b05ab7ca$export$55eea14cfe64612c);
$parcel$export(module.exports, "parseRoom", () => $92665236b05ab7ca$export$bde5503010f6075b);
$parcel$export(module.exports, "parseHubRoom", () => $92665236b05ab7ca$export$9e73e0d1874c6175);
$parcel$export(module.exports, "parseMessages", () => $92665236b05ab7ca$export$3146431b4885374e);
$parcel$export(module.exports, "parseMarker", () => $92665236b05ab7ca$export$1d3696c478d68206);
$parcel$export(module.exports, "parseRoomJoin", () => $92665236b05ab7ca$export$4c2d2dc7e00a99b0);
$parcel$export(module.exports, "parseHubRoomJoin", () => $92665236b05ab7ca$export$46ce4aed19a05545);
$parcel$export(module.exports, "parseNotifierJoin", () => $92665236b05ab7ca$export$770a404b9629c260);
$parcel$export(module.exports, "parseNotifierMessage", () => $92665236b05ab7ca$export$cd77b80583407a1e);
//
// private channel
//
// Parse the response of a join response.
//
const $92665236b05ab7ca$export$fc00c196eb0077fe = function(payload) {
    return {
        roomIds: payload.room_ids,
        user: $92665236b05ab7ca$export$59fec32f29a48331(payload.user)
    };
};
const $92665236b05ab7ca$export$59fec32f29a48331 = function(payload) {
    return {
        hubId: payload.hub_id,
        id: payload.id,
        insertedAt: new Date(payload.inserted_at),
        key: payload.key,
        name: payload.name,
        updatedAt: new Date(payload.updated_at)
    };
};
const $92665236b05ab7ca$export$e04f62a6c38c2e03 = function(payload) {
    return {
        id: payload.id,
        name: payload.name,
        users: payload.users.map($92665236b05ab7ca$var$parseUser)
    };
};
const $92665236b05ab7ca$export$1ffd67e37223c3ea = function(payload) {
    return {
        id: payload.id,
        insertedAt: new Date(payload.inserted_at),
        pushNotificationsEnabled: payload.push_notifications_enabled,
        pushNotificationsToken: payload.push_notifications_token,
        updatedAt: new Date(payload.updated_at)
    };
};
const $92665236b05ab7ca$export$54e25dcc64647fc8 = function(payload, user) {
    return {
        room: {
            hub: $92665236b05ab7ca$var$parseHub(payload.room.hub),
            id: payload.room.id
        },
        message: payload.message ? $92665236b05ab7ca$export$f2f615077a189f21(payload.message) : null,
        isNew: payload.marked_by.indexOf(user.id) == -1
    };
};
const $92665236b05ab7ca$export$2f0b934ecc764c66 = function(payload, user) {
    return {
        items: payload.items.map(function(item) {
            return $92665236b05ab7ca$export$54e25dcc64647fc8(item, user);
        })
    };
};
const $92665236b05ab7ca$export$a425ed7c68a2849d = function(payload, user) {
    return {
        room: {
            archived: payload.room.archived,
            assignedTo: payload.room.hub_user_id,
            attributes: payload.room.attributes,
            hubId: payload.room.hub_id,
            id: payload.room.id,
            user: $92665236b05ab7ca$var$parseUser(payload.room.user)
        },
        message: payload.message ? $92665236b05ab7ca$export$f2f615077a189f21(payload.message) : null,
        isNew: payload.marked_by.indexOf(user.id) == -1
    };
};
const $92665236b05ab7ca$export$55eea14cfe64612c = function(payload, user) {
    return {
        items: payload.items.map(function(item) {
            return $92665236b05ab7ca$export$a425ed7c68a2849d(item, user);
        })
    };
};
const $92665236b05ab7ca$export$bde5503010f6075b = function(payload) {
    return {
        attributes: payload.attributes,
        id: payload.id,
        user: $92665236b05ab7ca$var$parseUser(payload.user)
    };
};
const $92665236b05ab7ca$export$9e73e0d1874c6175 = function(payload) {
    return Object.assign($92665236b05ab7ca$export$bde5503010f6075b(payload), {
        archived: payload.archived,
        hubUser: payload.hub_user ? $92665236b05ab7ca$var$parseUser(payload.hub_user) : null
    });
};
const $92665236b05ab7ca$export$f2f615077a189f21 = function(payload) {
    return {
        html: payload.html,
        id: payload.id,
        insertedAt: new Date(payload.inserted_at),
        roomId: payload.room_id,
        text: payload.text,
        type: payload.type,
        updatedAt: new Date(payload.updated_at),
        upload: payload.upload ? $92665236b05ab7ca$var$parseUpload(payload.upload) : null,
        user: payload.user ? $92665236b05ab7ca$var$parseUser(payload.user) : null
    };
};
const $92665236b05ab7ca$export$3146431b4885374e = function(payload) {
    return {
        messages: payload.messages.map($92665236b05ab7ca$export$f2f615077a189f21)
    };
};
const $92665236b05ab7ca$export$1d3696c478d68206 = function(payload) {
    return {
        messageId: payload.message_id,
        updatedAt: new Date(payload.updated_at),
        userId: payload.user_id
    };
};
const $92665236b05ab7ca$export$4c2d2dc7e00a99b0 = function(payload) {
    return Object.assign($92665236b05ab7ca$export$bde5503010f6075b(payload), {
        messages: payload.messages.map($92665236b05ab7ca$export$f2f615077a189f21),
        markers: payload.markers.map((item)=>item == null ? null : $92665236b05ab7ca$export$1d3696c478d68206(item))
    });
};
const $92665236b05ab7ca$export$46ce4aed19a05545 = function(payload) {
    return Object.assign($92665236b05ab7ca$export$9e73e0d1874c6175(payload), {
        messages: payload.messages.map($92665236b05ab7ca$export$f2f615077a189f21),
        markers: payload.markers.map((item)=>item == null ? null : $92665236b05ab7ca$export$1d3696c478d68206(item))
    });
};
const $92665236b05ab7ca$export$770a404b9629c260 = function(payload) {
    return {
        messages: payload.messages.map($92665236b05ab7ca$export$f2f615077a189f21)
    };
};
const $92665236b05ab7ca$export$cd77b80583407a1e = function(payload) {
    return {
        message: $92665236b05ab7ca$export$f2f615077a189f21(payload.message)
    };
};
//
// helpers
//
// Helper for parseUserInboxItem.
//
const $92665236b05ab7ca$var$parseHub = function(payload) {
    return {
        id: payload.id,
        name: payload.name,
        slug: payload.slug
    };
};
// Helper for parseMessage.
//
const $92665236b05ab7ca$var$parseUpload = function(payload) {
    return {
        id: payload.id,
        mimeType: payload.mime_type,
        name: payload.name,
        original: {
            height: payload.original.height,
            url: payload.original.url,
            width: payload.original.width
        },
        preview: {
            height: payload.preview.height,
            url: payload.preview.url,
            width: payload.preview.width
        }
    };
};
// Helper for parseMessage, parseHubInboxRoom, parseInboxInfo, and others.
//
const $92665236b05ab7ca$var$parseUser = function(payload) {
    return {
        id: payload.id,
        key: payload.key,
        name: payload.name
    };
};

});

parcelRequire.register("c7j6M", function(module, exports) {

$parcel$export(module.exports, "validate", () => $8d24f6058788c783$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "validateOneOf", () => $8d24f6058788c783$export$c94d3e3ce00ce2cb);
$parcel$export(module.exports, "validateParams", () => $8d24f6058788c783$export$1f3bf48e9edf7d72);

var $dabqq = parcelRequire("dabqq");
// Check whether the given value conforms to the given spec. Return the value
// if the check passes, throw a UsageError otherwise.
//
// The spec is expected to be an object with the following keys:
//
// - type → The value must be of this type to pass the validation.
// - nullable → If this flag is set, the value could be null. By default, null
// would cause the validation to fail.
// - each → Only applicable when the type is 'iterable'. You can use this to
// provide a function to call on each element of the iterable; errors are left
// to propagate, causing the validation to fail.
//
// Example usage:
//
//  validate(true, {type: 'boolean'});
//  validate(42, {type: 'integer', nullable: false});
//  validate(null, {type: 'integer', nullable: true});
//  validate([], {type: 'iterable', each: (x) => validate(x, {type: 'map'})})
//
const $8d24f6058788c783$export$a22775fa5e2eebd9 = function(value, spec) {
    if (value === null) {
        if (spec.nullable) return null;
        else throw (0, $dabqq.UsageError)("This value cannot be null.");
    }
    switch(spec.type){
        case "boolean":
            if (typeof value != "boolean") throw (0, $dabqq.UsageError)(`${value} is not a boolean.`);
            return value;
        case "integer":
            if (!Number.isInteger(value)) throw (0, $dabqq.UsageError)(`${value} is not an integer.`);
            return value;
        case "string":
            if (typeof value != "string") throw (0, $dabqq.UsageError)(`${value} is not a string.`);
            return value;
        case "iterable":
            try {
                for (let item of value)if (spec.each) spec.each(item);
            } catch (error) {
                if (error instanceof TypeError) throw (0, $dabqq.UsageError)(`${value} is not an iterable.`);
                else throw error;
            }
            return value;
        case "map":
            if (typeof value != "object") throw (0, $dabqq.UsageError)(`${value} is not an object.`);
            return new Map(Object.entries(value));
        case "function":
            if (typeof value != "function") throw (0, $dabqq.UsageError)(`${value} is not a function.`);
            return value;
        case "datetime":
            if (!(value instanceof Date)) throw (0, $dabqq.UsageError)(`${value} is not a Date object.`);
            // yeah.. this is a magical string check
            if (value.toString() == "Invalid Date") throw (0, $dabqq.UsageError)(`${value} is not a valid datetime.`);
            return value;
    }
};
// Check whether the given value conforms to at least one of the given specs.
//
// Example usage:
//
//  validateOneOf(true, [{type: 'boolean'}, {type: 'integer'}]);
//  validateOneOf(0, [{type: 'string'}, {type: 'datetime'}]);
//
const $8d24f6058788c783$export$c94d3e3ce00ce2cb = function(value, specs) {
    const errors = [];
    for (const spec of specs)try {
        $8d24f6058788c783$export$a22775fa5e2eebd9(value, spec);
    } catch (error) {
        errors.push(error);
    }
    if (errors.length < specs.length) return value;
    else throw errors[0];
};
// Check whether each key of the given params object conforms to the spec
// provided under the same key in the spec object. If yes, return a Map with
// the validated key-value pairs; if no, throw a UsageError.
//
// In addition to the keys described above, individual spec objects may also
// contain the following keys:
//
// - optional → If this flag is set, the key may not be present in the params
// object. By default, missing keys cause the validation to fail.
//
// Example usage:
//
//  validateParams({x: true}, {x: {type: 'boolean'}})
//  validateParams({}, {s: {type: 'string', optional: true}})
//
const $8d24f6058788c783$export$1f3bf48e9edf7d72 = function(params, spec) {
    let map = new Map();
    for (let key of Object.keys(spec)){
        let value = params[key];
        if (typeof value == "undefined") {
            if (spec[key].optional) continue;
            else throw (0, $dabqq.UsageError)(`The parameter '${key}' is required.`);
        }
        try {
            value = $8d24f6058788c783$export$a22775fa5e2eebd9(value, spec[key]);
        } catch (error) {
            throw (0, $dabqq.UsageError)(`Invalid value passed for the parameter '${key}': ${error.message}`);
        }
        map.set(key, value);
    }
    return map;
};

});


parcelRequire.register("aM4q9", function(module, exports) {

$parcel$export(module.exports, "initNotifier", () => $7d81d0f5b2dc42f0$export$4249fa9d9ffe95c0);

var $geSD5 = parcelRequire("geSD5");

var $dabqq = parcelRequire("dabqq");

var $fJVWF = parcelRequire("fJVWF");

var $czhuu = parcelRequire("czhuu");
// Init a notifier object.
//
// Example usage:
//
//  let notifier = Kabelwerk.openNotifier();
//
//  notifier.on('ready', ({ messages }) => {});
//  notifier.on('updated', ({ message }) => {});
//
//  notifier.connect();
//
const $7d81d0f5b2dc42f0$export$4249fa9d9ffe95c0 = function(socket, user) {
    let dispatcher = (0, $geSD5.initDispatcher)([
        "error",
        "ready",
        "updated"
    ]);
    // internal state
    let lastMessageId = null;
    let ready = false;
    const updateLastMessageId = function(messages) {
        let max = null;
        for (const message of messages)if (message.id > max) max = message.id;
        if (max) lastMessageId = max;
    };
    // the phoenix channel
    let channel = null;
    const setupChannel = function() {
        channel = socket.channel(`notifier:${user.id}`, function() {
            let params = {};
            if (lastMessageId) params.after = lastMessageId;
            return params;
        });
        channel.on("message_posted", function(payload) {
            const message = (0, $czhuu.parseNotifierMessage)(payload).message;
            updateLastMessageId([
                message
            ]);
            dispatcher.send("updated", {
                message: message
            });
        });
        channel.join().receive("ok", function(payload) {
            (0, $fJVWF.default).info(`Joined the ${channel.topic} channel.`);
            const messages = (0, $czhuu.parseNotifierJoin)(payload).messages;
            updateLastMessageId(messages);
            if (ready) for (const message of messages)dispatcher.send("updated", {
                message: message
            });
            else {
                ready = true;
                dispatcher.send("ready", {
                    messages: messages
                });
            }
        }).receive("error", function(error) {
            (0, $fJVWF.default).error(`Failed to join the ${channel.topic} channel.`, error);
            dispatcher.send("error", (0, $dabqq.PushRejected)());
        }).receive("timeout", function() {
            dispatcher.send("error", (0, $dabqq.Timeout)());
        });
    };
    return {
        connect: function() {
            if (channel) throw (0, $dabqq.UsageError)("The connect() method was already called once.");
            setupChannel();
        },
        disconnect: function() {
            dispatcher.off();
            if (channel) channel.leave();
            channel = null;
            lastMessageId = null;
            ready = false;
        },
        on: dispatcher.on,
        off: dispatcher.off,
        once: dispatcher.once
    };
};

});

parcelRequire.register("7Bf0F", function(module, exports) {

$parcel$export(module.exports, "initRoom", () => $5887a1bb66111bad$export$e3da02bf05c1eae6);

var $geSD5 = parcelRequire("geSD5");

var $dabqq = parcelRequire("dabqq");

var $fJVWF = parcelRequire("fJVWF");

var $czhuu = parcelRequire("czhuu");

var $c7j6M = parcelRequire("c7j6M");
// Init a room object.
//
// A room object joins and maintains connection to a room channel.
//
const $5887a1bb66111bad$export$e3da02bf05c1eae6 = function(socket, user, roomId, callApi) {
    const isHubSide = Boolean(user.hubId);
    const dispatcher = (0, $geSD5.initDispatcher)([
        "error",
        "ready",
        "message_posted",
        "message_deleted",
        "marker_moved"
    ]);
    // internal state
    const room = {
        archived: null,
        attributes: null,
        hubUser: null,
        user: null
    };
    const markers = {
        own: null,
        other: null
    };
    let firstMessageId = null;
    let lastMessageId = null;
    let ready = false;
    // helper functions
    const updateFirstLastIds = function(messages) {
        if (messages.length) {
            let lastMessage = messages[messages.length - 1];
            if (!lastMessageId || lastMessage.id > lastMessageId) lastMessageId = lastMessage.id;
            if (!firstMessageId || messages[0].id < firstMessageId) firstMessageId = messages[0].id;
        }
    };
    const updateRoom = function(payload) {
        room.user = payload.user;
        room.attributes = payload.attributes;
        if (isHubSide) {
            if ("archived" in payload) room.archived = payload.archived;
            if ("hubUser" in payload) room.hubUser = payload.hubUser;
        }
    };
    const ensureReady = function() {
        if (!ready) throw (0, $dabqq.UsageError)("The room object is not ready yet.");
    };
    const ensureHubSide = function() {
        if (!isHubSide) throw (0, $dabqq.UsageError)("This method is only available for hub users.");
    };
    // the phoenix channel
    let channel = null;
    const setupChannel = function() {
        channel = socket.channel(`room:${roomId}`, function() {
            let params = {};
            if (lastMessageId) params.after = lastMessageId;
            return params;
        });
        channel.on("message_posted", function(payload) {
            const message = (0, $czhuu.parseMessage)(payload);
            if (message.id > lastMessageId) lastMessageId = message.id;
            dispatcher.send("message_posted", message);
        });
        channel.on("message_deleted", function(payload) {
            const message = (0, $czhuu.parseMessage)(payload);
            dispatcher.send("message_deleted", message);
        });
        channel.on("marker_moved", function(payload) {
            const marker = (0, $czhuu.parseMarker)(payload);
            if (marker.userId == user.id) {
                markers.own = marker;
                dispatcher.send("marker_moved", marker);
            } else if (markers.other == null || markers.other.messageId < marker.messageId) {
                markers.other = marker;
                dispatcher.send("marker_moved", marker);
            }
        });
        channel.join().receive("ok", function(payload) {
            (0, $fJVWF.default).info(`Joined the ${channel.topic} channel.`);
            const parse = isHubSide ? (0, $czhuu.parseHubRoomJoin) : (0, $czhuu.parseRoomJoin);
            payload = parse(payload);
            updateRoom(payload);
            updateFirstLastIds(payload.messages);
            if (ready) {
                // channel was rejoined
                for (let message of payload.messages)dispatcher.send("message_posted", message);
                if (payload.markers[0] != null && (markers.own == null || markers.own.messageId < payload.markers[0].messageId)) {
                    markers.own = payload.markers[0];
                    dispatcher.send("marker_moved", markers.own);
                }
                if (payload.markers[1] != null && (markers.other == null || markers.other.messageId < payload.markers[1].messageId)) {
                    markers.other = payload.markers[1];
                    dispatcher.send("marker_moved", markers.other);
                }
            } else {
                ready = true;
                markers.own = payload.markers[0];
                markers.other = payload.markers[1];
                dispatcher.send("ready", {
                    messages: payload.messages,
                    markers: payload.markers
                });
            }
        }).receive("error", function(error) {
            (0, $fJVWF.default).error(`Failed to join the ${channel.topic} channel.`, error);
            dispatcher.send("error", (0, $dabqq.PushRejected)());
        }).receive("timeout", function() {
            dispatcher.send("error", (0, $dabqq.Timeout)());
        });
    };
    return {
        // Update the room's inbox status to archived. Return a promise
        // resolving into an inbox info object.
        //
        // If until is set to a future Date object, the room will be
        // automatically un-archived at that point in time; by default the room
        // will not move out of the archive on its own.
        //
        // This method only works for hub users.
        //
        archive: function(until = null) {
            ensureHubSide();
            try {
                (0, $c7j6M.validate)(until, {
                    type: "datetime",
                    nullable: true
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The parameter 'until' must be either a valid datetime or null.");
            }
            return new Promise(function(resolve, reject) {
                channel.push("set_inbox_info", {
                    archive: true,
                    until: until
                }).receive("ok", function(payload) {
                    payload = (0, $czhuu.parseHubRoom)(payload);
                    updateRoom(payload);
                    resolve(payload);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to archive the room.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        connect: function() {
            if (channel) throw (0, $dabqq.UsageError)("The connect() method was already called once.");
            setupChannel();
        },
        // Delete a chat message (as long as it belongs to the connected user).
        // Return a promise resolving into the deleted message.
        //
        deleteMessage: function(messageId) {
            try {
                (0, $c7j6M.validate)(messageId, {
                    type: "integer"
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The message ID must be an integer.");
            }
            return new Promise(function(resolve, reject) {
                channel.push("delete_message", {
                    message: messageId
                }).receive("ok", function(payload) {
                    const message = (0, $czhuu.parseMessage)(payload);
                    resolve(message);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to delete the message.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        disconnect: function() {
            dispatcher.off();
            if (channel) channel.leave();
            channel = null;
            firstMessageId = null;
            lastMessageId = null;
            ready = false;
        },
        // Return the room's attributes.
        //
        getAttributes: function() {
            ensureReady();
            return room.attributes;
        },
        // Return the room's assigned hub user.
        //
        getHubUser: function() {
            ensureReady();
            ensureHubSide();
            return room.hubUser;
        },
        // Return the room's pair of markers.
        //
        getMarkers: function() {
            ensureReady();
            return [
                markers.own,
                markers.other
            ];
        },
        // Return the room's user.
        //
        getUser: function() {
            ensureReady();
            return room.user;
        },
        // Return a boolean indicating whether the room is marked as archived.
        //
        isArchived: function() {
            ensureReady();
            ensureHubSide();
            return room.archived;
        },
        // Load more messages, from earlier in the history. Return a promise
        // resolving into the list of fetched messages.
        //
        loadEarlier: function() {
            if (!firstMessageId) return Promise.resolve({
                messages: []
            });
            return new Promise(function(resolve, reject) {
                let push = channel.push("list_messages", {
                    before: firstMessageId
                });
                push.receive("ok", function(payload) {
                    let messages = (0, $czhuu.parseMessages)(payload).messages;
                    updateFirstLastIds(messages);
                    resolve({
                        messages: messages
                    });
                });
                push.receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to load earlier messages.", error);
                    reject((0, $dabqq.PushRejected)());
                });
                push.receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Move the user's marker for the room. Return a promise resolving into
        // the updated marker.
        //
        moveMarker: function(messageId) {
            if (messageId === undefined) {
                if (lastMessageId == null) throw (0, $dabqq.UsageError)("There must be at least one message in the room before moving the marker.");
                messageId = lastMessageId;
            }
            try {
                (0, $c7j6M.validate)(messageId, {
                    type: "integer"
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The message ID must be an integer.");
            }
            return new Promise(function(resolve, reject) {
                channel.push("move_marker", {
                    message: messageId
                }).receive("ok", function(payload) {
                    const marker = (0, $czhuu.parseMarker)(payload);
                    if (markers.own == null || markers.own.messageId < marker.messageId) markers.own = marker;
                    resolve(marker);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to move the room marker.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        off: dispatcher.off,
        on: dispatcher.on,
        once: dispatcher.once,
        // Create a new chat message. Return a promise resolving into the newly
        // created message.
        //
        postMessage: function(params) {
            params = (0, $c7j6M.validateParams)(params, {
                text: {
                    type: "string",
                    optional: true
                },
                uploadId: {
                    type: "integer",
                    optional: true
                }
            });
            if (params.size != 1) throw (0, $dabqq.UsageError)("Exactly one parameter is required.");
            const pushParams = params.has("text") ? {
                text: params.get("text")
            } : {
                upload: params.get("uploadId")
            };
            return new Promise(function(resolve, reject) {
                channel.push("post_message", pushParams).receive("ok", function(payload) {
                    const message = (0, $czhuu.parseMessage)(payload);
                    if (message.id > lastMessageId) lastMessageId = message.id;
                    resolve(message);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to post the new message.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Post a new file upload. Return a promise resolving into the newly
        // created upload.
        //
        postUpload: function(file) {
            const formData = new FormData();
            formData.append("file", file);
            return callApi("POST", `/uploads`, formData);
        },
        // Update the room's inbox status to not archived. Return a promise
        // resolving into an inbox info object.
        //
        // This method only works for hub users.
        //
        unarchive: function() {
            ensureHubSide();
            return new Promise(function(resolve, reject) {
                let push = channel.push("set_inbox_info", {
                    archive: false
                });
                push.receive("ok", function(payload) {
                    payload = (0, $czhuu.parseHubRoom)(payload);
                    updateRoom(payload);
                    resolve(payload);
                });
                push.receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to unarchive the room.", error);
                    reject((0, $dabqq.PushRejected)());
                });
                push.receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Update the room's attributes. Return a promise resolving into the
        // (updated) attributes object.
        //
        updateAttributes: function(attributes) {
            try {
                attributes = (0, $c7j6M.validate)(attributes, {
                    type: "map"
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The room attributes must be an object.");
            }
            return new Promise(function(resolve, reject) {
                channel.push("set_attributes", {
                    attributes: Object.fromEntries(attributes)
                }).receive("ok", function(payload) {
                    payload = (0, $czhuu.parseRoom)(payload);
                    updateRoom(payload);
                    resolve(payload.attributes);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to update the room's attributes.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        },
        // Update the room's assigned hub user. Return a promise resolving into
        // an inbox info object.
        //
        // This method only works for hub users.
        //
        updateHubUser: function(hubUserId) {
            ensureHubSide();
            try {
                (0, $c7j6M.validate)(hubUserId, {
                    type: "integer",
                    nullable: true
                });
            } catch (error) {
                throw (0, $dabqq.UsageError)("The hub user ID must be an integer.");
            }
            return new Promise(function(resolve, reject) {
                channel.push("set_inbox_info", {
                    hub_user: hubUserId
                }).receive("ok", function(payload) {
                    payload = (0, $czhuu.parseHubRoom)(payload);
                    updateRoom(payload);
                    resolve(payload);
                }).receive("error", function(error) {
                    (0, $fJVWF.default).error("Failed to update the room's assigned hub user.", error);
                    reject((0, $dabqq.PushRejected)());
                }).receive("timeout", function() {
                    reject((0, $dabqq.Timeout)());
                });
            });
        }
    };
};

});




//# sourceMappingURL=index.57009d48.js.map
